import React from 'react'
import { string, bool, number } from 'prop-types'

import classNames from 'src/common/helpers/class-names'
import { priceLabelToNumber } from 'shared/util/price'
import Banner from './banner'

import './_style.scss'
import './_linksave-config.scss'

const blk = 'link-save-banner'

const LinkSaveBanner = (props) => {
  const {
    className, isBundle, bundleDiscount, promoOfferTypeCode,
  } = props
  const allMeatStickerTypes = [6, 8, 13, 15]
  if (
    (!isBundle &&
    !bundleDiscount &&
    !priceLabelToNumber(bundleDiscount) > 0) &&
    (allMeatStickerTypes.indexOf(Number(promoOfferTypeCode)) <= -1)
  ) {
    return null
  }

  return (
    <div className={classNames({ className, blk })}>
      <Banner {...props} />
    </div>
  )
}

LinkSaveBanner.propTypes = {
  className: string,
  isBundle: bool,
  bundleDiscount: number,
  promoOfferTypeCode: string,
}

LinkSaveBanner.defaultProps = {
  className: '',
  isBundle: false,
  bundleDiscount: 0,
  promoOfferTypeCode: '',
}

export default LinkSaveBanner



// WEBPACK FOOTER //
// ./shared/interim/product/link-save-primary-banner/index.js